import {gql} from '@apollo/client';

import {isInaccessibleInfo} from 'auth/RequestAccess';
import ExcludeInaccessible from 'graphql-client/ExcludeInaccessible';
import {ProteinNamesQuery} from 'molbio/aa-sequences/util/__generated/ProteinNamesQuery';

type ProteinName = ProteinNamesQuery['proteins'][number];
type AccessibleProteinName = ExcludeInaccessible<ProteinName>;

function isAccessibleProtein(protein: ProteinName): protein is AccessibleProteinName {
  return !isInaccessibleInfo(protein);
}

export const PROTEIN_NAMES_QUERY = gql`
  query ProteinNamesQuery($ids: [StrictString!]!) @skipAudit @engComponent(name: MOLBIO) {
    proteins(ids: $ids) {
      ... on RegistryItemInterface {
        id
        displayLabel
      }
    }
  }
`;

export function getAccessibleProteinNamesById(data: ProteinNamesQuery): Record<string, string> {
  const accessibleResults: Array<AccessibleProteinName> = data.proteins.filter((protein) =>
    isAccessibleProtein(protein)
  );
  return accessibleResults.reduce<Record<string, string>>((acc, protein) => {
    acc[protein.id] = protein.displayLabel;
    return acc;
  }, {});
}
